import { GitHubMark } from "./GitHubMark";

export function Footer() {
  return (
    <footer className="site-footer">
      <div>
        <strong>Agent Harness 工程</strong>
        <p>独立中文知识重构 · 非官方翻译</p>
      </div>
      <div>
        <span>代码 MIT</span>
        <span>内容 CC BY-SA 4.0</span>
      </div>
      <a
        href="https://github.com/yizhiyanhua-ai/agent-harness-engineering-zh"
        target="_blank"
        rel="noreferrer"
      >
        <GitHubMark />
        在 GitHub 上参与维护
      </a>
    </footer>
  );
}
